import { PatientCard } from "@components/cards/PatientCard";
import { Box } from "@mui/material";
import { patientCardContainer } from "./PatientCardsStyles";
import { IInOfficeEvent } from "../../../types/formAssignments/IInOfficeEvent";
import { EFormStatus } from "src/enums/EFormStatus";
import { useGetFeatureFlag } from "@hooks/useGetFeatureFlag";
import { EFeatureFlags } from "src/enums/EFeatureFlags";

export interface PatientCardsProps {
  events: IInOfficeEvent[];
  selectedEvent: IInOfficeEvent | null;
  setSelectedEvent: (event: IInOfficeEvent) => void;
}

export const PatientCards = ({
  events,
  selectedEvent,
  setSelectedEvent,
}: PatientCardsProps) => {
  const { isEnabled: isFamilyFeatureEnabled } = useGetFeatureFlag(
    EFeatureFlags.FastrAppFamilyEnabled
  );

  if (events.length === 0) {
    return <Box sx={patientCardContainer}>No patients found</Box>;
  }

  return (
    <Box sx={patientCardContainer}>
      {events.map((event) => {
        const forms = event.formAssignment?.forms ?? [];
        const totalForms = forms.length;
        const completedForms = forms.filter(
          (form) => form.status === EFormStatus.Submitted
        ).length;
        const completedStatus =
          completedForms === totalForms ? "Completed" : "Incomplete";
        return (
          <PatientCard
            width={60}
            height={60}
            key={event.uniqueKey}
            patientKey={event.uniqueKey}
            isSelected={selectedEvent?.uniqueKey === event.uniqueKey}
            onClick={() => setSelectedEvent(event)}
            dob={event.patient.dateOfBirth || ""}
            chartNumber={event.patient.chartId}
            patientName={`${event.patient.firstName} ${event.patient.lastName}`}
            packageName={event.formAssignment?.packageName || "Custom Package"}
            totalForms={totalForms}
            completedForms={completedForms}
            status={completedStatus || ""}
            age={event.patient.age || 0}
            np={event.patient.isNewPatient || false}
            avatar={event.patient.avatar || ""}
            appointmentDate={
              isFamilyFeatureEnabled
                ? event.appointment?.startsAt
                  ? event.appointment.startsAt
                  : undefined
                : event.appointment?.startsAt
                  ? new Date(
                      event.appointment.startsAt * 1000
                    ).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                  : undefined
            }
            appointmentTime={event.appointment?.checkInTime || undefined}
          />
        );
      })}
    </Box>
  );
};
